var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var choices = require('../libs/choices');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var systemReportModel = require('../../../../models/reports/incidentsPerShiftReport');
var pikaday = require('../libs/pikaday');
var downloadFile = require('../layout/components/downloadFile');

var Action = Object.create(Model);

Object.assign(Action, systemReportModel);


modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


Action.editDialogue = function (record) {
  Action.initForm();
  Action.downloadError = prop(null);
  Action.getUserGroups = function(){
    loaders.requestWithLoader({
      url: '/api/v1/group/',
      method: "GET"
    }).then(function(result){
      Action.groups = result.map(function (group, idx) {
        return {key: group.name, value: group['@rid']}
      })
    })
  }
  Action.getUserGroups();

  key.setScope('modal');
  key('enter', 'modal', submit);

  var submit = function () {

    /*Action.save()
    .then(function(data){
      loaders.requestWithLoader({
        url: "/api/v1/point/"+record['@rid'].slice(1),
        method: "PUT",
        body: {offset:parseInt(Action.form.offset())},
      })
      .then(function(data){
        modal.vm.close()
      })
      .catch(function(e){
         alerts.vm.add({detail: '' + e})
         console.log(e)
      })
    })*/

    
  };

  var download = function () {
    var group = Action.form.groups() ? Action.form.groups().slice(1) : ''
    var url = "/api/v1/report/incidentspershift/?startDate=" + moment(Action.form.startDate()) + '&endDate=' + moment(Action.form.endDate()) +'&' + m.buildQueryString({groups: Action.form.groups()});
    Action.downloadError(null);
    downloadFile(url)
    .then(function () {
      modal.vm.close();
    })
    .catch(function (err) {
      Action.downloadError(err && err.message ? err.message : 'Download failed');
      m.redraw();
    });
  };

  modal.vm.title('System Report: ')
  modal.vm.body = Action.view,
  modal.vm.buttons([
    {
      label: "Download",
      class: "btn-good",
      func: download
    }
  ]);
  modal.vm.open();
}


Action.view = function () {
  if (!Action.groups) return
  return m('form', {role:'form'}, [
    m('label', 'Start Date:'),
    m('div.mr2-l.w-100', [
      m(pikaday, {value: Action.form.startDate, dateFormat: 'm/d/Y h:i K'})
    ]),
    m('label', 'End Date:'),
    m('div.mr2-l.w-100', [
      m(pikaday, {value: Action.form.endDate, dateFormat: 'm/d/Y h:i K'})
    ]),
    m('label', 'User Groups:'),
    m(choices, {
      data: Action.groups,
      value: Action.form.groups
    }),
    Action.downloadError() ? m('div.red.mt2', Action.downloadError()) : null
  ])  
}

module.exports = Action;
